import FontUploadIcon from 'components/icons/font-upload-icon/index.vue'
export default {
  name: 'live-uploader-disable',

  components: {
    FontUploadIcon
  }
}
